/**
 * Main JS file for Paragon Underscores theme
 *
 * Will be compiled into js/main.js
 */

import { handleAlertBanner } from './modules/alertBanner';
import { mobileNavigation } from './modules/mobileNavigation';
import { searchModal } from './modules/searchModal';
import { stickyHeaders } from './modules/stickyHeaders';

// run all functions on page load.
document.addEventListener('DOMContentLoaded', function () {
	handleAlertBanner();
	mobileNavigation();
	searchModal();
	stickyHeaders();
});
